// component
import { Icon } from '@iconify/react';

// ----------------------------------------------------------------------

const getIcon = (name) => <Icon icon={name} width={22} height={22} />;

// Fonction pour créer une notification
const createNotification = (count) => {
  if (count === 0) return null;
  
  return (
    <span className="inline-flex items-center justify-center px-2 py-1 text-xs font-bold leading-none text-white bg-red-500 rounded-full min-w-[20px] h-5">
      {count > 9999 ? '9999+' : count}
    </span>
  );
};

const navConfig = [
  {
    title: 'Tableau de bord',
    path: '/dashboard',
    icon: getIcon('mdi:view-dashboard'),
  },
  {
    title: 'Publier',
    path: '/dashboard/publish',
    icon: getIcon('el:bullhorn'),
  },/*
  {
    title: 'Demande d\'objet perdu',
    path: '/dashboard/products/perdus',
    icon: getIcon('ep:finished'),
  },*/
  {
    title: 'Objets Trouvés',
    path: '/dashboard/products/trouves',
    icon: getIcon('gg:search-found'),
    info: null, // Sera remplacé dynamiquement
  },
  /*{
    title: 'Objets Perdus',
    path: '/dashboard/products/perdus',
    icon: getIcon('akar-icons:question'),
  },*/
  {
    title: 'Objets Restitués',
    path: '/dashboard/products/restitues',
    icon: getIcon('la:hands-helping'),
  },
  {
    title: 'Objets à expédier',
    path: '/dashboard/products/aexpedie',
    icon: getIcon('fa6-solid:truck-fast'),
    info: null, // Sera remplacé dynamiquement
  },/*
  {
    title: 'Objets Payés à envoyer',
    path: '/dashboard/products/payes',
    icon: getIcon('flat-color-icons:paid'),
  },*/
  {
    title: 'Objets partis en livraison',
    path: '/dashboard/products/envoyes',
    icon: getIcon('akar-icons:shipping-box-v1'),
  },
  {
    title: 'Messages',
    path: '/dashboard/messages',
    icon: getIcon('noto-v1:left-speech-bubble'),
  },
  //  path: '/dashboard/user',
  {
    title: 'Stockages',
    path: '/dashboard/stockage',
    icon: getIcon('eva:shopping-bag-fill'),
  }
];

export default navConfig;